enum BlogPostStatusType {
  DRAFT = '0',
  PENDING = '1',
  VALIDATED = '2',
  PUBLISHED = '3',
  DELETED = '4',
}

export default BlogPostStatusType
